import React from 'react';
import { Routes, Navigate, Route } from 'react-router-dom';

import { InsightsCustomerProvidedVariablesRoute } from './InsightsCustomerProvidedVariablesRoute';
import { InsightsFundingOverviewRoute } from './InsightsFundingOverviewRoute';
import { InsightsLtvRoute } from './InsightsLtvRoute';
import { InsightsBorrowingBaseRoute } from '~/borrower/routes/insights/InsightsBorrowingBaseRoute';
import { InsightsConcentrationRoute } from '~/borrower/routes/insights/InsightsConcentrationRoute';
import { InsightsEligibilityRoute } from '~/borrower/routes/insights/InsightsEligibilityRoute';
import { InsightsExpensesFeesRoute } from '~/borrower/routes/insights/InsightsExpensesFeesRoute';
import { InsightsFinancialsRoute } from '~/borrower/routes/insights/InsightsFinancialsRoute';
import { InsightsPerformanceRoute } from '~/borrower/routes/insights/InsightsPerformanceRoute';
import { InsightsPortfolioCovenantsRoute } from '~/borrower/routes/insights/InsightsPortfolioCovenantsRoute';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

export const InsightsRouter = () => {
  const flags = useFeatureFlags();
  return (
    // Paths relative to "/insights/*"
    <Routes>
      <Route
        path="/funding-overview"
        element={<InsightsFundingOverviewRoute />}
      />
      <Route path="/borrowing-base" element={<InsightsBorrowingBaseRoute />} />
      <Route path="/eligibility" element={<InsightsEligibilityRoute />} />
      <Route path="/concentration" element={<InsightsConcentrationRoute />} />
      <Route path="/performance" element={<InsightsPerformanceRoute />} />
      <Route path="/ltv" element={<InsightsLtvRoute />} />
      <Route path="/expenses-fees" element={<InsightsExpensesFeesRoute />} />
      <Route
        path="/financials"
        element={
          flags.displayFinancialCovenantInsights ? (
            <InsightsFinancialsRoute />
          ) : (
            <Navigate to="/insights/funding-overview" />
          )
        }
      />
      <Route
        path="/portfolio-covenants"
        element={
          // !TODO @eldarshamukhamedov Move feature flag logic inside the route component
          flags.displayPortfolioCovenants ? (
            <InsightsPortfolioCovenantsRoute />
          ) : (
            <Navigate to="/insights/funding-overview" />
          )
        }
      />
      <Route
        path="/customer-provided-variables"
        element={<InsightsCustomerProvidedVariablesRoute />}
      />
      <Route path="/*" element={<Navigate to="/insights/funding-overview" />} />
    </Routes>
  );
};
